import { render } from "./CDataTable.vue?vue&type=template&id=d40e723c&scoped=true"
import script from "./CDataTable.vue?vue&type=script&lang=js"
export * from "./CDataTable.vue?vue&type=script&lang=js"

import "./CDataTable.vue?vue&type=style&index=0&id=d40e723c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d40e723c"]])

export default __exports__